var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-items"},[_c('v-app-bar',{attrs:{"flat":""}},[_c('div',{staticClass:"text-center"},[_c('logo',{staticClass:"logo"})],1)]),_c('v-divider'),_c('menu-items')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }